module.exports = __webpack_public_path__ + "img/home-3.f779b483.png";